import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Heart } from "lucide-react";
import flytLogo from "@/assets/flyt-logo.svg";

export function PublicLayout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      {/* Sticky header */}
      <header className="sticky z-50 border-b border-border bg-card/95 backdrop-blur supports-[backdrop-filter]:bg-card/85" style={{ top: "var(--debug-banner-h, 0px)" }}>
        <div className="mx-auto flex max-w-2xl items-center justify-between px-4 py-3">
          <Link to="/" className="flex items-baseline gap-2.5 font-display text-xl font-bold">
            <img src={flytLogo} alt="Flyt logo" className="h-7 w-7 self-center" />
            <span className="text-primary-dark opacity-95 text-[1.18rem]" style={{ fontFamily: "'DM Sans', sans-serif", fontWeight: 500, letterSpacing: '-0.01em' }}>Flyt</span>
          </Link>
          <Button variant="ghost" size="sm" asChild>
            <Link to="/login">Logg inn</Link>
          </Button>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1">{children}</main>

      {/* Footer */}
      <footer className="border-t border-border py-8 text-center text-sm text-muted-foreground space-y-3">
        <p className="font-medium text-foreground/80 flex items-center justify-center gap-1">Utviklet med <Heart className="h-4 w-4 text-red-500 fill-red-500" /> av foreldre – for foreldre.</p>
        <div className="flex items-center justify-center gap-4 flex-wrap">
          <Link to="/personvern" className="hover:text-foreground transition-colors">Personvern</Link>
          <span className="text-border">·</span>
          <Link to="/vilkar" className="hover:text-foreground transition-colors">Vilkår</Link>
          <span className="text-border">·</span>
          <a href="mailto:hei@inwent.no" className="hover:text-foreground transition-colors">Kontakt</a>
        </div>
        <p>© {new Date().getFullYear()} Flyt · Org.nr 834 661 012</p>
      </footer>
    </div>
  );
}
